import { useNavigate, useSearch } from '@tanstack/react-router';

import {
  parseDashboardRouteSearch,
  serializeDashboardRouteFilters,
  type DashboardRouteFilters,
  type DashboardRouteSearch,
} from './dashboardRouteSearch';
import type { DashboardDateRange } from './model';

export function useDashboardRouteFilters() {
  const navigate = useNavigate({ from: '/' });
  const search = useSearch({ from: '/' });
  const filters = parseDashboardRouteSearch(search);

  const update = (updater: (current: DashboardRouteFilters) => DashboardRouteFilters) => {
    void navigate({
      search: (current: DashboardRouteSearch) =>
        serializeDashboardRouteFilters(updater(parseDashboardRouteSearch(current))),
      replace: true,
    });
  };

  return {
    filters,
    setRange: (range: DashboardDateRange) => {
      update((current) => ({ ...current, range }));
    },
  };
}
